import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Countermeasure } from '../../../types/drbfm';
import { CountermeasureCard, ReviewCountermeasure } from './workbench/CountermeasureCard';
import { WorkbenchSection } from './workbench/WorkbenchSection';

interface Props {
  countermeasures: Countermeasure[];
  isLoading: boolean;
  onReview: ReviewCountermeasure;
}

const CountermeasureWorkbench: React.FC<Props> = ({ countermeasures, isLoading, onReview }) => {
  const { t } = useTranslation();
  return (
  <WorkbenchSection
    title={t('drbfm.workflow.workbenches.countermeasureReviewTitle', '対策レビュー')}
    description={t('drbfm.workflow.workbenches.countermeasureReviewDescription', '対象原因、作用機序、検証方法、合格基準を一体で確認します。')}
    emptyMessage={t('drbfm.workflow.workbenches.countermeasureEmpty', '対策候補はまだありません。')}
    isEmpty={countermeasures.length === 0}
  >
    {countermeasures.filter((measure) => measure.reviewStatus !== 'superseded').map((measure) => (
      <CountermeasureCard
        key={measure.id}
        measure={measure}
        isLoading={isLoading}
        onReview={onReview}
      />
    ))}
  </WorkbenchSection>
  );
};

export default CountermeasureWorkbench;
